export const LOGO_WIDTH = 460;
export const LOGO_HEIGHT = 150;
export const TEXT_FIELD_WIDTH = 750;
export const CARD_MARGIN = 15;
export const CARD_WIDTH = 796;
